import React from "react";
import "./benefits.scss";

const Benefits = () => {
  return (
    <div className="l-benefits">
      <h2 className="addEffect">Co zyskujesz, kupując nasz kurs?</h2>
      <ul>
        <li>
          <div className="x-content">
            <div className="x-title">Lekcje video</div>
            <div className="x-text">
              Zawierają zarówno wiedzę teoretyczną jak i dokładne instrukcje
              konfiguracji - teraz dwie wersje!
            </div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Dostęp bez limitu czasu</div>
            <div className="x-text">Możesz do nich wrócić w każdej chwili.</div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Dostęp do aktualizacji tego kursu</div>
            <div className="x-text">
              Które będą przygotowywane w przyszłości.
            </div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">
              Gotowe rozwiązania dostosowane do realiów polskich firm
            </div>
            <div className="x-text">
              Możesz je na bieżąco wprowadzać w życie.
            </div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Pomoc eksperta</div>
            <div className="x-text">Cotygodniowe spotkania online.</div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Zamknięta grupa na FB</div>
            <div className="x-text">
              Dzięki czemu będziesz mógł na bieżąco wyjaśniać swoje wątpliwości
              i wymieniać doświadczenia.
            </div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Bonus 1 - dodatkowe lekcje</div>
            <div className="x-text"></div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">
              Bonus 2 - nagranie rzeczywistego wdrożenia u Klienta
            </div>
            <div className="x-text"></div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Możliwość obniżenia podatku</div>
            <div className="x-text">Faktura za kurs.</div>
          </div>
        </li>
        <li>
          <div className="x-content">
            <div className="x-title">Gwarancja Satysfakcji</div>
            <div className="x-text">
              Jeśli kurs nie będzie dla Ciebie wartościowy, to masz 30 dni aby
              zrezygnować.
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Benefits;
